import { useEffect, useState } from 'react';

export const OFFER_SECONDS = 17 * 60 + 34;

/**
 * Counts down from `total` seconds and restarts automatically when it hits zero.
 */
export function useCountdown(total: number = OFFER_SECONDS) {
  const [remaining, setRemaining] = useState(total);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? total : prev - 1));
    }, 1000);
    return () => window.clearInterval(interval);
  }, [total]);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  const pad = (value: number) => String(value).padStart(2, '0');

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    remaining,
  };
}
